import React from 'react'
import { Link } from 'react-router-dom'
import { LocationDescriptor } from 'history'

// Components
import { PublicationItemFragment } from '@sketch/gql-types'
import { Text } from '@sketch/components'

// Hooks
import { useFlag } from '@sketch/modules-common'

// Styles
import {
  Container,
  HeartButton,
  Name,
  PublicationThumbnail,
  TitleWrapper,
} from './GridPublicationItem.styles'

export interface GridPublicationItemProps {
  className?: string
  publication: PublicationItemFragment
  url?: LocationDescriptor
  showProfile?: boolean
}

const GridPublicationItem = (props: GridPublicationItemProps) => {
  const { className, publication, url, showProfile } = props

  const isHeartButtonAvailable = useFlag('publication-hearts')

  const publicationName = publication.share.name
  const workspaceName = publication.workspaceProfile?.workspace.name

  const content = (
    <>
      <PublicationThumbnail publication={publication} />
      <TitleWrapper>
        <Name>{publicationName}</Name>
        {isHeartButtonAvailable && (
          <HeartButton
            publication={publication}
            flavour="list"
            trackHeartCount
          />
        )}
      </TitleWrapper>
      {showProfile && (
        <Text
          textStyle="copy.quaternary.standard.C"
          as="span"
          overflow="ellipsis"
        >
          {workspaceName}
        </Text>
      )}
    </>
  )

  if (url) {
    return (
      <Link className={className} to={url}>
        <Container title={publicationName}>{content}</Container>
      </Link>
    )
  }

  return (
    <Container className={className} title={publicationName}>
      {content}
    </Container>
  )
}

export default GridPublicationItem
